import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { IntegrationDanskeSpilData } from './Data';

export interface IntegrationDanskeSpilState extends BaseIntegrationState {
  brand?: string;
}

export class IntegrationDanskeSpilModel extends BaseIntegration<IntegrationDanskeSpilData, IntegrationDanskeSpilState> {
  parse(data: IntegrationDanskeSpilData) {
    super.parse(data);

    if (data.settings) {
      this.state.brand = data.settings.ensigthen.brand;
    } else {
      this.state.brand = undefined;
    }
  }

  hasVueComponent() {
    return false;
  }

  authorSignature(): string {
    return 'Istvan Bovan';
  }
}
